import {
    getUserProfileDoc,
    sendToKeap,
    user,
    userStatus,
} from "@utils/underhood/firebase"
import { getDoc, onSnapshot, setDoc } from "firebase/firestore"
import { derived, get, writable } from "svelte/store"
import { registerUserStatusCallback } from "@utils/helpers/unload-promise"

export const profileReady = writable(false)

/**
 * WARNING : This is the firebase functions too.
 * If you change it, make sure you also change
 * in functions.
 */
export type Profile = {
    firstname: string
    lastname: string

    /**
     * This holds information for keap registration
     * for the back-end server to process when
     * the email has been verified
     *
     * false: this means that we have already registered
     * regular: this means that we should sign up to Keap's regular list
     * newsletter: this means that we should sign up to Keap's newsletter list
     */
    keap: false | "regular" | "newsletter"
}
export const profile = writable<Profile>()
function resetUser() {
    profile.set({
        firstname: "Guest",
        lastname: "",
        keap: "regular",
    })
}
resetUser()

let unsubscribeListener: () => void = () => null

registerUserStatusCallback({
    unload: async () => {
        unsubscribeListener()
    },
    load: async (status) => {
        if (status == "verified" || status == "unverified") {
            await new Promise<void>((ready) => {
                unsubscribeListener = onSnapshot(getUserProfileDoc(), (doc) => {
                    if (!doc.exists) {
                        // Could be in the process of registering ?
                        console.error("Doc does not exist!")
                        profile.set({
                            firstname: "Noname",
                            lastname: "",
                            keap: "regular",
                        })
                    } else {
                        // User doc exists
                        const profileData = doc.data() as Profile
                        profile.set(profileData)
                        checkVerifiedForKeap()
                    }
                    ready()
                })
            })
        } else {
            // they are NOT logged in
            resetUser()
        }
    },
})

let keapLock = false
async function checkVerifiedForKeap() {
    try {
        if (
            keapLock == false &&
            get(user) &&
            get(user)!.emailVerified &&
            get(profile) &&
            get(profile).keap
        ) {
            keapLock = true
            console.log("set: ", get(profile))
            console.log("Sending to keap!")
            await sendToKeap()
            keapLock = false
        }
    } catch (e) {
        console.warn(e)
        keapLock = false
    }
}

// user.subscribe(() => checkVerifiedForKeap())

//@ts-ignore
globalThis.profileReady = () => {
    return get(profileReady)
}
